import s from './ProjectCard.module.scss';
import Link from "next/link";
import Image from "next/image";
import {Fragment} from "react";
import {TextIconLink} from "@/app/[locale]/common/components/TextIconLink/TextIconLink";
import {CircleArrowIcon} from "@/app/[locale]/common/assets/CircleArrowIcon/CircleArrowIcon";
import {TProjectCard} from "@/app/[locale]/common/components/ProjectCard/types";
import {TShortText} from "@/app/[locale]/projects/types";

export const ProjectCard = ({ id, title, shortText, img }: TProjectCard) => {
    return (
        <div className={s.projectCard}>
            <Link href={`projects/${id}`} className={s.projectCard_imageContainer}>
                {
                    img ?
                        <Image src={img} alt={title} width={500} height={500}/>
                        : 'no image'
                }
            </Link>

            <div className={s.projectCard_content}>
                <label>{title}</label>

                {
                    shortText  ?
                        shortText.map((el: TShortText, index: number) => (
                            <Fragment key={index}>
                                <span className={s.projectCard_content_title}>{el.title}</span>
                                <p>{el.description}</p>
                            </Fragment>
                        ))
                        : <p>{''}</p>
                }

                <TextIconLink href={`projects/${id}`} icon={<CircleArrowIcon/>}>
                    Learn more
                </TextIconLink>
            </div>
        </div>
    );
};